<template lang="pug">
div.loyalty-back
  ods-sub-header(
    :is-absolute='false'
    :stretch='false').actionsCupons
    div.actionsLeft
      router-link(:to="{ name: namePath }")
        ods-button(type="text" icon="ods-icon-arrow-left")
      p.glue {{ $t('loyalty.TemplatesDetails2') }}
  div.template-details
    div(v-if="this.data && this.data.registros").template-details__1
      div
        button(@click="cambiaTab(pantallageneral)" :class="activar === 0 ? 'template-details__1-1bact' : 'template-details__1-1b'") {{ this.$t('loyalty.mainData') }}
      div
        button(@click="cambiaTab(pantallaconfiguracion)" :class="activar === 1 ? 'template-details__1-1bact' : 'template-details__1-1b'" ) {{ this.$t('loyalty.configuration') }}
      div
        button(@click="cambiaTab(pantallaconversion)" :class="activar === 2 ? 'template-details__1-1bact' : 'template-details__1-1b'") {{ this.$t('loyalty.couponCoversion') }}
      div
        button(@click="cambiaTab(pantallacomercios)" :class="activar === 3 ? 'template-details__1-1bact' : 'template-details__1-1b'") {{ this.$t('loyalty.commerces') }}
    div(v-if="this.data && this.data.registros").template-details__2
      div(v-if="datosprincipales")
        datos-plantilla(:data="this.data.registros")
      div(v-if="configuracion")
        configuracion-table(:data="this.data.registros")
      div(v-if="conversion")
        conversion-table(:data="this.data.registros")
      div(v-if="comercios")
        comercios-table(:data="this.data.registros")
    div(v-if="this.data && this.data.registros").template-details__3
        imagen-cupon(:data="this.data.registros" :imagen="this.data.registros.imagen")
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DatosPlantilla from '@/components/loyalty/Coupons/DatosPlantilla'
import ConfiguracionTable from '@/components/loyalty/Coupons/ConfiguracionTable'
import ConversionTable from '@/components/loyalty/Coupons/ConversionTable'
import ComerciosTable from '@/components/loyalty/Coupons/ComerciosTable'
import ImagenCupon from '@/components/loyalty/Coupons/ImagenCupon'
export default {
  name: 'PlantillasDetails',
  data () {
    return {
      data: {},
      activar: 0,
      activeTab: 'general',
      pantallageneral: 'general',
      pantallaconfiguracion: 'configuracion',
      pantallaconversion: 'conversion',
      pantallacomercios: 'comercios',
      datosprincipales: true,
      configuracion: false,
      conversion: false,
      comercios: false,
      namePath: 'LoyaltyCoupons'
    }
  },
  components: {
    'datos-plantilla': DatosPlantilla,
    'configuracion-table': ConfiguracionTable,
    'conversion-table': ConversionTable,
    'comercios-table': ComerciosTable,
    'imagen-cupon': ImagenCupon
  },
  computed: {
    ...mapGetters({
      getLang: 'getLang'
    })
  },
  methods: {
    ...mapActions(['getProgram', 'getTemplateDetails']),
    cambiaTab (pantalla) {
      if (pantalla === 'general') {
        this.activar = 0
        this.datosprincipales = true
        this.configuracion = false
        this.conversion = false
        this.comercios = false
      } else if (pantalla === 'configuracion') {
        this.activar = 1
        this.datosprincipales = false
        this.configuracion = true
        this.conversion = false
        this.comercios = false
      } else if (pantalla === 'conversion') {
        this.activar = 2
        this.datosprincipales = false
        this.configuracion = false
        this.conversion = true
        this.comercios = false
      } else if (pantalla === 'comercios') {
        this.activar = 3
        this.datosprincipales = false
        this.configuracion = false
        this.conversion = false
        this.comercios = true
      }
    }
  },
  watch: {
    async getLang (data, oldData) {
      const response = await this.getTemplateDetails()
      this.data = response
      return this.data
    }
  },
  async mounted () {
    // console.log('holi')
    const response = await this.getTemplateDetails()
    this.data = response
    return this.data
  }
}
</script>

<style lang="scss">
.template-details{
  margin-top: -30px;
  max-height: 86vh;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(100px, 200000px);
  grid-template-columns: 21.6% 33.9% 44.4%;
&__1{
background-color: #EAF0F5;
fill: solid;
padding-top: rem(40);
padding-left: rem(8);
padding-right: rem(8);
max-height: 86vh;
}
&__1-1b{
  background-color: #EAF0F5;
  border: none;
  color: #000000;
  text-align: left;
  font-size: rem(12);
  cursor: pointer;
  padding-bottom: rem(9);
  padding-top: rem(9);
  width: 100%;
  padding-left: rem(8);
  font-family: Soho;
  font-style: regular;
}
&__1-1b:hover{
  background-color: #D5E1EA;
  border: none;
  font-weight: 500;
  color: #2E6C99;
  text-align: left;
  font-size: rem(12);
  cursor: pointer;
  padding-bottom: rem(9);
  padding-top: rem(9);
  width: 100%;
  padding-left: rem(8);
  font-family: Soho;
  font-style: regular;
}
&__1-1bact{
  background-color: #D5E1EA;
  fill: solid;
  border: none;
  color: #2E6C99;
  font-weight: 600;
  text-align: left;
  font-size: rem(12);
  cursor: pointer;
  padding-bottom: rem(9);
  padding-top: rem(9);
  width: 100%;
  padding-left: rem(8);
  font-family: Soho;
  font-style: regular;
}
&__2{
  background-color: #FFFFFF;
}
&__3{
  background-color: #F9F9FB;
}
}

.loyalty-back{
  overflow: hidden;
}

</style>
